function params(obj = {}) {
    return _.map(obj, (v, k) => {
        const key = encodeURIComponent(k);
        const value = key === 'f64' ? _.toString(v) : encodeURIComponent(_.toString(v));
        return (value && value !== 'undefined') ? `${key}=${value}` : ''; //TODO handle undefined
    })
        .filter(value => value !== '')
        .join('&');
}

export default (_string) => {
    const string = _.isObject(_string) ? params(_string) : _string;
    if (/^\?.+$/.test(string)) return string;
    return string === '' ? string : '?' + string;
}

